// These type defintions compensate for the lack of
// types provided by the GLU component
export interface IDateConfig {
  holidays: Array<string>;
  businessDaysOfWeek: Array<number>;
  earliestDay: string;
  nextAvailableDay: string;
  latestDay: string;
  processOnHolidays: boolean;
  processOnNonBusinessDays: boolean;
}

export enum FrequencyType {
  SEMIMONTHLY = 'SEMIMONTHLY',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export enum DayType {
  DATE = 'DATE',
  WEEK = 'WEEK'
}

export enum NthWeekOfMonth {
  LAST = 5,
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4
}

export enum Month {
  JANUARY = 1,
  FEBRUARY = 2,
  MARCH = 3,
  APRIL = 4,
  MAY = 5,
  JUNE = 6,
  JULY = 7,
  AUGUST = 8,
  SEPTEMBER = 9,
  OCTOBER = 10,
  NOVEMBER = 11,
  DECEMBER = 12
}

export type Day =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31;

export type WeeklyRecurrence = {
  weeklyRecurrence: {
    frequency: 1 | 2 | 3 | 4;
    weekDays: [boolean, boolean, boolean, boolean, boolean, boolean, boolean];
  };
};

export type NthOfMonthRecurrence = {
  monthlyRecurrence: {
    day: Day;
    frequency: number;
    month: Month;
  };
};

export type NthOfWeekRecurrence = {
  monthlyRecurrence: {
    frequency: number;
    month: Month;
    dayOfWeek: DayOfWeek;
    weekOfMonth: 1;
  };
};

// prettier-ignore
export type RecurrenceType =
  | WeeklyRecurrence
  | NthOfMonthRecurrence
  | NthOfWeekRecurrence;

export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY'
}

export enum SchedulerDay {
  'DAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY'
}
